<template>
    <div class="app">
        <TopNav></TopNav>
        <div class="center">
            <!-- 解决方案模块 -->
            <div class="csy-way">
                <div class="content_row">
                    <div class="csy-way-box1">
                        <div class="title_content">
                            <div class="title">
                                <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                                <h1>数字农贸整体解决方案</h1>
                                <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                            </div>
                        </div>
                        <div class="project-box1">
                            <p>
                                数字农贸系统从人、物、资金、信息角度对农贸市场进行全方位数字化、智慧化升级改造。搭建“数字化基建、数字化管理、数字化营销”三大版块，满足不同角色（市场集团、管理员、商户、消费者）需求，为市场日常管理、增值服务、营销运营提供更多帮助。
                            </p>
                            <span>农贸市场痛点：</span>
                            <p class="project-hd">1.管理难：从业商户文化水平有限，沟通管理困难；</p>
                            <p class="project-hd">2.工作难：工作内容包括食品安全监管、人员健康管理、商品追溯、消防安全管控、营销活动策划等等，工作繁杂多样，急需工具提升效率；</p>
                            <p class="project-hd">
                                3.增长难：在社区门店、生鲜电商、商超卖场，多业态、多巨头“围剿”下，农贸市场呈现客群固化、流量难提升的状态，仅维持现状不足以带领农贸市场继续发展。</p>
                            <span>数字化解决方案：</span>
                            <img src="../assets/sznm.png" alt="">
                            <i>数字农贸应用场景</i>
                            <p class="project-hd">硬件：电子秤、商户屏、交互引导屏、大数据展示屏、监控、水电表等场景硬件全接入。</p>
                            <p class="project-hd">软件：“1+1+N”架构——集团+农贸市场两层结构，搭配N项应用，根据需求自由组合，实现数据实时流转，角色多端联动。</p>
                            <span>升级改造成效：</span>
                            <span class="project-other">1.市场管理方</span>
                            <p>（1）提效率：提升市场日常经营管理效率，无纸化、协同化办公；</p>

                            <p>（2）增收益：提升市场运营能力，丰富运营手段，增加市场收益；</p>

                            <p>（3）重服务：提升市场服务能力与服务水平，重视消费者体验。</p>
                            <span class="project-other">2.农贸商户</span>
                            <p> （1）低费用：收款通道费用降低；</p>

                            <p>（2）高品质：农产品安全、品质、新鲜度有保障；</p>

                            <p>（3）降成本：降低商户经营成本，包括采购成本、运输成本、租金成本等；</p>
                            <p>（4）增收益：增加商品销量、客户数量，增加经营收益。</p>
                            <span class="project-other">3. 消费者</span>
                            <p>（1）低价格：农产品价格低，实惠生活；</p>

                            <p>（2）高品质：农产品安全、品质、新鲜度有保障；</p>

                            <p>（3）优服务：丰富的服务内容与优质的数字化服务体验，如线上菜场在线交易，聚合支付减少现金交易。</p>
                        </div>
                    </div>
                    <div class="csy-way-box1">
                        <div class="title_content">
                            <div class="title">
                                <img src="../assets/tb.png" style="margin-right: .4rem;" alt="">
                                <h1>数字农批整体解决方案</h1>
                                <img src="../assets/tb 1.png" style="margin-left: .4rem;" alt="">
                            </div>
                        </div>
                        <div class="project-box1">
                            <p>
                                围绕人、车、货、场进行全面数字化改造升级，整合物流、资金流、信息流，以提升农批市场综合运营与服务能力为目标，不仅对旧流程进行数字化升级再造，还对新生态进行引进融合。打造以商户为核心，运营服务为驱动力的新型智慧化农批市场。
                            </p>
                            <span>农批市场痛点：</span>
                            <span class="project-other">1. 数据采集难</span>
                            <p>各类交易、采购、库存、运营、管理数据采集难，难以实现数据驱动效应。</p>
                            <span class="project-other">2. 园区管理难度大</span>
                            <p>空间大、系统多、数据杂，难以实现对人、车、货、钱的有效统一管理。</p>
                            <span class="project-other">3. 经营模式传统</span>
                            <p>绝大多数批发市场仍然以传统的物业租赁为主，赢利模式单一。</p>
                            <span class="project-other">4. 食品安全追溯难</span>
                            <p>在线化工具缺失，商户不配合，追溯数据难采集。</p>
                            <span class="project-other">5. 园区服务能力弱</span>
                            <p>加工、仓储、物流、金融等配套服务少，商户粘性差，招商困难。</p>
                            <span>数字化解决方案：</span>
                            <img src="../assets/zhnp.png" alt="">
                            <i>数字农批应用场景</i>
                            <p class="project-hd">硬件：地磅、电子秤、智慧屏、监控、水电表、检测设备等场景硬件全接入。</p>
                            <p class="project-hd">软件：“8+3”架构——8大系统模块加3大用户端</p>
                            <h5>8大系统：</h5>
                            <p>1. 园区管理：车辆，设施，人员，农批现场一体化管理。</p>
                            <p>2. 商户管理：招商、电子台账、物业缴费、商户信用。</p>
                            <p>3. 电子化交易结算：统一收银台，资金结算。</p>
                            <p>4. 商户进销存：开单，进货、库存、销售管理，客户管理，结算管理。</p>
                            <p>5. 食品安全追溯：产地合格证，合格供应商，质量追溯，商品召回。</p>
                            <p>6. 服务能力：安全检测，金融，物流，冷库，加工，包装，配送。</p>
                            <p>7. 线上农批：B2B，商户集货，团购，二批，零售店。</p>
                            <p>8. 大数据分析：人流，车流，物流，价格，产地，渠道，现金流动，数据报表，趋势分析与预测。</p>
                            <h5>3大用户端：</h5>
                            <p>1. 市场管理端：PC+手机</p>
                            <p>2. 商户运营端：PC+平板+手机</p>
                            <p> 3. 采购商端：手机 </p>
                            <span>升级改造成效：</span>
                            <span class="project-other">1.市场管理方</span>
                            <p>（1）提效率：提升市场日常经营管理效率，无纸化、协同化办公；</p>

                            <p>（2）增收益：提升市场运营能力，提升市场坪效，丰富运营手段，增加市场收益；</p>

                            <p>（3）丰服务：提供更多运营服务抓手，让农批运营有的放矢，有效提升。</p>
                            <span class="project-other">2.农批商户</span>
                            <p>（1）快做账：快速记录账单，系统自动帮忙做账、分析，免去算账繁琐；</p>

                            <p>（2）少错账：系统记账，规避错账、漏账，统计、提醒欠款情况，减少坏账比例；</p>

                            <p>（3）提运营：对商品采购、销售、库存情况进行清晰量化管理，提升商户运营能力；</p>
                            <p>（4）增收益：提供产地、销售渠道信息，提供仓储、加工、配送等增值服务，增加商户收益。</p>
                            <span class="project-other">3. 采购商</span>
                            <p>（1）可追溯：所有采购商品可清晰追溯，定位问题，交易有保障；</p>

                            <p>（2）优服务：丰富的服务内容与优质的数字化服务体验，为采购商提供更多选择与更高性价比；</p>

                            <p>（3）明消费：所有采购订单清晰可查，可视化统计展现，掌握采购动态。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomNav></BottomNav>
    </div>
</template>

<script>
import TopNav from '../components/TopNav.vue'
import BottomNav from '../components/BottomNav.vue'
export default {
    components: { TopNav, BottomNav },
    data() {
        return {

        }
    },
    created() { },
    mounted() { },
    methods: {},
}
</script>

<style lang="less" scoped>
.app {
    width: 100vw;
    height: 100vh;
    background-size: cover;
    z-index: -1;
    overflow-x: hidden;
}

.center {
    width: 100%;
    min-height: calc(100vh - .8333rem - 5.9063rem);
    margin-top: .8333rem;
}

.content_row {
    width: 100%;
    height: 100%;
    padding: 0 4.25rem;
    box-sizing: border-box;
}

.title_content {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    align-items: center;
}

.title_content .title {
    display: flex;
    align-items: center;
}

.title_content img {
    width: 1.1458rem;
    height: .2292rem;
}

.title_content h1 {
    font-size: .3958rem;
}

.title_content p {
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
    margin-top: .2917rem;
}

.csy-way {
    display: flex;
    width: 100%;
    height: 63rem;
    margin-top: 1rem;
    /* background-color: pink; */
    text-align: center;
    box-sizing: border-box;
}

.csy-way-box1 {
    margin-top: .5208rem;
}

.csy-way h1 {
    height: .5rem;
    font-size: .3958rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #232A24;
    line-height: .5rem;
    // margin-top: 1.0417rem;
    /* margin-left: 353px; */
}


.csy-way .project-box1 {
    margin-top: 0.8rem;
}

.csy-way .project-box1 p {
    font-size: .2292rem;
    text-indent: 2em;
    line-height: .4167rem;
    text-align: left;
}

.csy-way .project-box1 span {
    display: block;
    font-size: .3125rem;
    font-weight: 700;
    text-align: left;
    margin-top: .42rem;
    margin-bottom: .32rem;
    color: #000;
}

.project-hd {
    margin-bottom: .2083rem;
}

.csy-way .project-box1 img {
    width: 100%;
}

.csy-way .project-box1 i {
    display: block;
    font-style: italic;
    font-size: .18rem;
    font-weight: 400;
    color: #454845;
    margin: .3125rem;
}

.csy-way .project-box1 .project-other {
    display: block;
    font-size: .25rem;
    font-weight: 700;
    text-align: left;
    margin-top: .25rem;
    margin-bottom: .25rem;
    color: #000;
}

.csy-way-box1 h1 img {
    /* width: 1.1458rem; */
    height: .2292rem;
    vertical-align: middle;
    padding: 0 .3125rem;
    box-sizing: border-box;
}

.csy-way .project-box1 h5 {
    font-size: .25rem;
    color: rgb(139, 170, 74);
    text-align: left;
    margin-bottom: .2604rem;
    margin-top: .3125rem;
}
</style>